<template>
  <div class="collector-page">
    <Button type="primary" icon="plus-round" v-if="permissions === true" @click="edit(-1)">{{$t("device.collector.New_collector")}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true" @click="edit(-1)" disabled>{{$t("device.collector.New_collector")}}</Button>
        <Input class="info" v-model="search" :placeholder="$t('device.collector.name')">
           <Button slot="append" icon="ios-search" @click="handleSearch()"></Button>
           <Button slot="append" icon="refresh" @click="handleReset()"></Button>
        </Input>
    <Table class="collector-table" highlight-row stripe border :columns="columns" :data="datas"></Table>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Collector',
  data () {
    return {
      columns: [
        // { type: 'index', title: '序号', fixed: 'left' },
        {
          title: this.$t('device.collector.operating'),
          key: 'action',
          fixed: 'left',
          render: (h, params) => {
            if (this.permissions === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, this.$t('device.collector.edit'))
                // h('Button', {
                //   props: {
                //     type: 'error',
                //     size: 'small'
                //   },
                //   on: {
                //     click: () => {
                //       if (confirm(this.$t('device.collector.delete_message'))) {
                //         this.remove(params.index)
                //       }
                //     }
                //   }
                // }, this.$t('device.collector.delete'))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, this.$t('device.collector.edit'))
                // h('Button', {
                //   props: {
                //     type: 'error',
                //     size: 'small',
                //     disabled: true
                //   }
                // }, this.$t('device.collector.delete'))
              ])
            }
          }
        },
        { title: this.$t('device.collector.name'), key: 'name', sortable: true, fixed: 'left', sortType: 'asc', width: 120, ellipsis: true },
        { title: this.$t('device.collector.deviceNo'), key: 'deviceNo', sortable: true, width: 95 },
        {
          title: this.$t('device.collector.routerID'),
          key: 'routerID',
          render: (h, params) => {
            let no = ''
            for (let r of this.routers) {
              if (r.id === params.row.routerID) {
                no = r.AnotherName
              }
            }
            return h('span', no)
          }
        },
        { title: this.$t('device.collector.type'), key: 'type', sortable: true },
        {
          title: this.$t('device.collector.computeType'),
          key: 'computeType',
          render: (h, params) => {
            let no = ''
            for (let c of this.computeTypes) {
              if (c.id === params.row.computeType) {
                no = c.name
              }
            }
            return h('span', no)
          }
        },
        { title: this.$t('device.collector.length'), key: 'length' },
        { title: this.$t('device.collector.count'), key: 'count', sortable: true },
        { title: this.$t('device.collector.width'), key: 'width', sortable: true },
        { title: this.$t('device.collector.deviceCompany'), key: 'deviceCompany' },
        { title: this.$t('device.collector.deviceModel'), key: 'deviceModel' },
        { title: this.$t('device.collector.buyTime'), key: 'buyTime' },
        { title: this.$t('device.collector.deviceLifeTime'), key: 'deviceLifeTime' },
        { title: this.$t('device.collector.remark'), key: 'remark' }
      ],
      datas: [],
      collectorList: [],
      search: '',
      computeTypes: [],
      routers: [],
      permissions: false
    }
  },
  methods: {
    edit (index) {
      let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'CollectorEdit', params: { id } })
    },
    remove (index) {
      this.$api.collector.delete(this.datas[index].id).then(() => {
        this.datas.splice(index, 1)
      })
    },
    handleSearch () {
      this.datas = []
      for (let i = 0; i < this.collectorList.length; i++) {
        let p = this.collectorList[i]
        if (p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          this.datas.push(p)
        }
      }
    },
    handleReset () {
      this.datas = this.collectorList
    }
  },
  mounted () {
    Api.computeType.list().then(res => {
      this.computeTypes = res
      this.computeTypes[0].name = this.$t('device.collector.roller')
      this.computeTypes[1].name = this.$t('device.collector.weft_density')
    })
    Api.router.list().then(res => {
      this.routers = res.routers
    })
    Api.collector.list().then(res => {
      this.collectorList = res.collectors
    })
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'device' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.collector.list().then(res => {
      next(vm => { vm.datas = res.collectors })
    })
  }
}
</script>
<style scoped>
  .collector-page {
    padding: 10px;
  }
  .collector-page .info{
    width: 33.33333%
  }
  .collector-table {
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// List.vue?1f66470e